import { render } from "./VesselCapacity.vue?vue&type=template&id=03432c28&scoped=true"
import script from "./VesselCapacity.vue?vue&type=script&lang=js"
export * from "./VesselCapacity.vue?vue&type=script&lang=js"

import "./VesselCapacity.vue?vue&type=style&index=0&id=03432c28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03432c28"]])

export default __exports__